import { Button, styled } from "@mui/material";

const SecondaryButton = styled(Button)(({ theme }) => ({
    width: "100%",
    fontSize: "14px",
    fontFamily: "Geist, sans-serif",
    backgroundColor: "#fff",
    border: "1px solid #1F4CB3",
    borderRadius: "8px",
    color: "#1F4CB3",
    "&:hover": {
        color: "#1E5EDB",
        border: "1px solid #1E5EDB",
        backgroundColor: "#fff"
    },
    "&:active": {
        color: "#1F4CB3",
        border: "1px solid #1F4CB3",
        backgroundColor: "#DBEDFE"
    },
    "&:disabled": {
        color: "#C1CACB",
        border: "1px solid #C1CACB",
        backgroundColor: "#fff"
    },
    marginTop: "8px",
    marginBottom: "8px",
    boxShadow: "none",

    // Dark mode styles using media query
    '@media (prefers-color-scheme: dark)': {
        backgroundColor: "transparent",
        border: "1px solid #93CDFD",
        color: "#93CDFD",
        "&:hover": {
            color: "#60B1FA",
            border: "1px solid #60B1FA",
            backgroundColor: "transparent"
        },
        "&:active": {
            color: "#93CDFD",
            border: "1px solid #93CDFD",
            backgroundColor: "rgba(74, 144, 226, 0.12)"
        },
        "&:disabled": {
            color: "#666666",
            border: "1px solid #666666",
            backgroundColor: "transparent"
        }
    }
}));

export default SecondaryButton;